import { Events } from 'backbone';

const OfflineStore = Object.assign({}, Events);

window.addEventListener('online', () => OfflineStore.trigger('app:online'));
window.addEventListener('offline', () => OfflineStore.trigger('app:offline'));

export default OfflineStore;
